/**
 * Created by synerzip on 02/01/16.
 */
import React from 'react';
import { TransitionGroup, CSSTransition } from 'react-transition-group';

class AnimatedLinearProgress extends React.Component{

    constructor(props) {
        super(props);
        this.state = {
            percentage: null
        }
    }

    animate(percentage){

        this.setState({percentage: percentage});
    }

    componentDidMount(){
        this.animate(this.props.percentage);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.percentage !== this.props.percentage) {
            this.animate(this.props.percentage);
        }
    }

    render(){
        if(this.state.percentage != null) {
            return (
                <TransitionGroup>
                    <CSSTransition key="linear" classNames="example" timeout={{ enter: 500, exit: 1000, appear: 1000 }} appear>
                        <div className="line-graph-outer">
                            <div className="line-graph-innner" style={{width:this.state.percentage+'%'}}></div>
                        </div>
                    </CSSTransition>
                </TransitionGroup>
            );
        }else{
            return(<div />);
        }
    }

}

export default AnimatedLinearProgress;